import { Navigate } from '@exam-management/router';
import { createContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { generateSimilarityMatrix } from '../../utils';

import type {
  QSetSimilarityResultContextData,
  QSetSimilarityResultProviderProps,
  QSetSimilarityResultRouteState,
} from './types';

export const QSetSimilarityResultContext = createContext<
  QSetSimilarityResultContextData | undefined
>(undefined);

export default function QSetSimilarityResultProvider(
  props: Readonly<QSetSimilarityResultProviderProps>,
) {
  const { children } = props;
  const location = useLocation();
  const state = location.state as QSetSimilarityResultRouteState;

  const uniqueQSetCodes = useMemo(() => {
    return {
      drafts: (state?.draftQSets ?? []).map(({ code }) => code),
      published: (state?.publishedQSets ?? []).map(({ code }) => code),
    };
  }, [state]);

  const contextValue = useMemo(
    () => ({
      courseId: state?.courseId ?? '',
      type: state?.checkType ?? 'DRAFT_TO_DRAFT',
      uniqueQSetCodes,
      similarityResult: {
        id: state?.id ?? '',
        data: state?.similarityResult ?? [],
        matrix: generateSimilarityMatrix(state?.similarityResult ?? []),
        duplicationRate: state?.duplicationRate ?? 0,
      },
    }),
    [state],
  );

  if (!state?.similarityResult) {
    return <Navigate to='/exam-courses' replace />;
  }

  return (
    <QSetSimilarityResultContext.Provider value={contextValue}>
      {children}
    </QSetSimilarityResultContext.Provider>
  );
}
